module.exports = __webpack_public_path__ + "img/group2_03.2d18d334.png";